import { formatNumber } from "accounting-js";

export const FormatWithPrecision = (number) => {       
    if(number == null) { return ''; }

    return formatNumber(number, { precision: 2, thousand: " ", decimal: "," });        
}